export default (url) => {
  // Regular expression pattern to match a full URL with protocol (http, https, etc.)
  const pattern = /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[:?\d]*)\S*$/;
  return pattern.test(url);
};
